import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./login.scss";
import { loginValidation } from "../../utils/validation";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../utils/firebase";

const Login = () => {
  const [isValidationError, setIsValidationError] = useState(null);
  const emailRef = useRef();
  const passwordRef = useRef();

  const handleLogin = () => {
    const emailValue = emailRef.current.value;
    const passwordValue = passwordRef.current.value;
    const validationError = loginValidation(emailValue, passwordValue);
    setIsValidationError(validationError);
    if (validationError) return;

    signInWithEmailAndPassword(auth, emailValue, passwordValue)
      .then((userCredential) => {
        // eslint-disable-next-line
        const user = userCredential.user;
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        setIsValidationError(errorCode + "-" + errorMessage);
      });
  };
  return (
    <div className="login-section">
      <div className="login-content">
        <div className="login-text">
          <h1 className="login-title">Log in</h1>
          <label className="label email">Email :</label>
          <input
            className="input adress"
            type="email"
            placeholder="veer@gmail.com"
            ref={emailRef}
            required
          ></input>
          <label className="label password">Password :</label>
          <input
            className="input pass"
            type="password"
            placeholder="*********"
            ref={passwordRef}
            required
          ></input>
          <p className="text-red-600 text-left">{isValidationError}</p>
          <button className="btn mb-4" onClick={handleLogin}>
            Log in
          </button>
          <p>Don't have a account with us! Register here</p>
          <Link to="/register">
            <button style={{ textDecoration: "none" }} className="btn login">
              New User
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
